const BLANK_STATE = {
// step 1
    coverageId: '',
    insuredName: '',
    ratingDates: {},
    ratingPeriod: '',

// step 2
    fullName: '',
    phoneNumber: '',
    emailAddress: '',
// step 3
    hasValidCoverageAndRating: {},
    userType: '',
    currentAgentOrAccountant: '',
// step 4
    mutualCompanyAffiliated: '',
    mutualCompanyExplanation: '',
//  step 5
    quarter: '',
// files
    authorizationFile: '',
    authorizationFileName: '',
    ownershipFile: '',
    ownershipFileName: '',
// step 6 & 7
    nonOfficers: [],
    officers: [],

    correctionsFile: '',
    correctionsFileName: '',
    correctionsExplanation: '',
// step 8
    signature: '',

    passedFinalValidations: false,
    finishedWithClassAndWage: false,
    saving: false,
    loading: false,
    csecLoginOpen: false,
};

const resetStateToStep = (step, state) => {
    var temp = Object.assign({}, BLANK_STATE);
    temp.step = step;

    if (step >= 1) {
        temp.coverageId = state.coverageId;
        temp.insuredName = state.insuredName;

        temp.ratingDates = state.ratingDates;
        temp.ratingPeriod = state.ratingPeriod;

        temp.contactBureauEmail = state.contactBureauEmail;
        temp.fullName = state.fullName;
        temp.phoneNumber = state.phoneNumber;
        temp.emailAddress = state.emailAddress;
    }

    if (step >= 2) {
        temp.fullName = state.fullName;
        temp.phoneNumber = state.phoneNumber;
        temp.emailAddress = state.emailAddress;
    }

    if (step >= 3) {
        temp.hasValidCoverageAndRating = state.hasValidCoverageAndRating;
    }

    return temp;
}

export default resetStateToStep;